import {type GetterTree} from 'vuex';

const getters: GetterTree<ModuleSchoolState, RootState> = {
    entitiesClosed(state)
    {
        return state.entitiesClosed;
    },
    search(state)
    {
        return state.search;
    }
};

export default getters;